export const UNIVERSITY = 'University';
